import React from "react";
import { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { CapacityOption } from "../template_offering_listing_base";
import { TemplateOfferingListingMeetingRoom } from "../template_offering_listing_meeting_room";
import { useRoomsAnalytics } from "./rooms_analytics";
import { usePartnerConfig } from "./rooms_partner_config";

const Theme = lazyWithRetry(() => import("./rooms_theme"));

const capacityOptions: CapacityOption[] = [
  { label: "1 - 10", value: { minCapacity: 1, maxCapacity: 10 } },
  { label: "10+", value: { minCapacity: 11 } },
];

export function OfferingRoomsListingMeetingRoom() {
  useRoomsAnalytics();
  const partnerConfig = usePartnerConfig();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingListingMeetingRoom
        filterConfig={{ capacity: true, location: true, capacityOptions }}
        partnerConfig={partnerConfig}
        data={{
          title: "Meeting Rooms",
          description:
            "Various sized dedicated meeting rooms, luxurious design and equipped with all the technology you’ll need. Easily book a meeting room that best suits your needs and get ready for a whole new meeting experience.",
        }}
      />
    </Fragment>
  );
}
